import { cn } from '../../lib/utils';
import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { FIELD_SURFACE } from './Input';

/**
 * Sdílená textová oblast (acm-textarea) — stejný surface jako Input.
 */
interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  size?: 'sm' | 'md';
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, size = 'md', ...props }, ref) => {
    const sizes = {
      sm: 'h-24 px-3 text-xs py-2',
      md: 'h-32 px-4 text-sm py-3',
    };

    return (
      <textarea
        className={cn(
          'flex w-full min-h-[6rem] resize-y rounded-lg',
          FIELD_SURFACE,
          sizes[size],
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';
